import * as yup from "yup";

const ConfirmAccountSchema = yup.object().shape({
    email: yup
        .string()
        .email("Please enter a valid email!")
        .required("Please Enter Email"),
    code: yup
        .string()
        .required("Please Enter Verification Code")
});

export default ConfirmAccountSchema;